<template>
  <a-config-provider :locale="language === 'English' ? enUS : zhCN">
    <div class="mt-4 w-full relative">
      <div class="w-full flex items-center mt-4 ml-4 mb-4">
        <img
            style="width: 18px; height: 18px"
            src="@/assets/machineD3.png"
            alt=""
        />
        <div class="size18 ml-2">{{ langObj['设备事件'] }}（{{ warningTotal }}{{ getLanguage('条') }}）</div>
        <div class="flex-1"></div>
        <div
            @click="viewMore"
            class="opt8"
            style="font-size: 12px; cursor: pointer"
        >
          {{ langObj['查看更多'] }} >
        </div>
      </div>

      <div class="mt-2 w-full flex">
        <div class="flex-1"></div>
        <div
            @click="()=>{(warningType = 1); getMachineWarning()}"
            :style="{ background: warningType === 1 ? '#171325ff' : '' }"
            class="btn1 cursor-pointer"
        >
          {{ langObj['报警事件'] }}
        </div>
        <div
            @click="()=>{(warningType = 2); getMachineWarning()}"
            :style="{ background: warningType === 2 ? '#171325ff' : '' }"
            class="btn1 cursor-pointer"
            style="margin-left: 10px"
        >
          {{ langObj['检修记录'] }}
        </div>
        <div class="flex-1"></div>
      </div>

      <div class="mt-2 w-full px-2" v-if="warningType === 1">
        <div class="w-full flex items-center justify-center mb-4">
          <div
              class="btn2-o flex items-center cursor-pointer"
              @click="addRepair"
              style="padding: 4px 8px;max-width: 145px;"
          >
            <plus-outlined class="mr-1"/>
            {{ langObj['添加检修记录'] }}
          </div>
          <div
              class="btn2-o ml-2 flex items-center cursor-pointer"
              @click="deleteWaring"
              style="padding: 4px 18px; width: 145px"
          >
            <close-outlined class="mr-1"/>
            {{ langObj['批量关闭报警'] }}
          </div>
        </div>

      </div>

      <div class="mt-2 w-full cursor-pointer">
        <div
            v-for="(item, index) in machineWarningData"
            :key="index"
            @click="viewReport(item)"
            class="box5 mt-2"
        >
          <div class="w-full flex items-center">
            <img
                v-if="item.type === 1"
                style="width: 18px; height: 18px"
                src="@/assets/zhenduan.png"
                alt=""
            />
            <img
                v-if="item.type === 2"
                style="width: 18px; height: 18px"
                src="@/assets/weixiu.png"
                alt=""
            />
            <img
                v-if="item.type === 4"
                style="width: 18px; height: 18px"
                src="@/assets/menxian.png"
                alt=""
            />
            <div
                v-if="item.type === 1"
                :style="{ color: conditionList.find((p) =>   p.value.includes(item.condition)  )?.color }"
                class="ml-2"
                style="font-size: 16px"
            >
              {{ langObj['诊断报警'] }}：{{
                langObj[conditionList.find((p) => p.value.includes(item.condition))?.label || ""]
              }}
            </div>
            <div class="ml-2" v-if="item.type === 2">{{ langObj['现场维修'] }}</div>
            <div class="ml-2" v-if="item.type === 4">{{ langObj['门限报警'] }}</div>
            <div class="flex-1"></div>
            <div v-if="  item.reportIds && item.reportIds.length && item.type === 1 "
                 class="box6 opt8">
              {{ langObj['诊断报告'] }}
            </div>
            <div
                v-if="
                      item.reportIds && item.reportIds.length && item.type === 2
                    "
                class="box6 opt8"
            >
              {{ langObj['检修报告'] }}
            </div>
          </div>

          <div class="mt-2">{{  getDiagLang(item) ||item.diagnosticNotes }}</div>
          <div class="mt-2 opt6" style="font-size: 12px">
            {{ transformLocalDate(item.date) }}
          </div>
        </div>
      </div>

      <div v-if="reportId"
           style="position: absolute; left: -820px; width: 800px; top: -20px">
        <MaintenanceReportDetailComponent v-if="reportType === 2 || reportType === 3" ref="maint"
                                          @cancel="cancelReport"></MaintenanceReportDetailComponent>
        <DiagnosticReportDetails2Component v-if="reportType === 1" ref="Diagn"
                                           @cancel="cancelReport"></DiagnosticReportDetails2Component>
      </div>
    </div>

    <!-- Add maintenance record -->
    <a-modal
        v-model:visible="visibleAdd"
        :closable="false"
        :footer="null"
        :bodyStyle="{ background: '#080718ff' }"
        style="top: 15%"
        width="1200px"
        :maskClosable="false"
    >
      <div style="color: #fff">
        <div class="w-full flex">
          <div class="flex-1"></div>
          <div class="cursor-pointer" @click="visibleAdd = false">
            <close-outlined style="font-size: 20px"/>
          </div>
        </div>
        <div class="text-center w-full" style="font-size: 24px">
          {{ langObj['添加检修记录'] }}
        </div>

        <div class="w-full flex items-center">
          <span style="font-size: 20px"
          > {{ langObj['故障信息(请勾选此次维修的故障项)'] }}
         </span
         >
          <!-- <div class="btn3-o">Add fault</div> -->
        </div>

        <a-table
            :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
            :columns="columns"
            :data-source="nohandleList"
            :pagination="false"
            rowKey="_id"
            style="background-color: #080718ff"
        >
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'condition'">
              <div class="flex items-center">
                <div class="ml-2">
                  {{ langObj[conditionList.find((p) => p.value === text)?.label || ""] }}
                </div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'date'">
              {{ transformBeiJingDate(text) }}
            </template>
            <template v-if="column.dataIndex === 'diagnosticNotes'">
              {{getDiagLang(record)}}
            </template>
          </template>
        </a-table>

        <div class="mt-4" style="font-size: 20px">{{ langObj['维修详情'] }}</div>

        <a-form
            ref="formRef"
            name="advanced_search"
            class="ant-advanced-search-form"
            :model="form"
            :label-col="{ style: { width: '180px' } }"
        >
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item
                  name="begin"
                  :label="langObj['开始时间']"
                  :rules="[{ required: true, message: langObj['请选择开始时间'] }]"
                  :allowClear="false"
              >
                <a-date-picker
                    v-model:value="form.begin"
                    show-time
                    :placeholder="langObj['请选择时间']"
                />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                  name="end"
                  :label="langObj['结束时间']"
                  :rules="[{ required: true, message: langObj['请选择结束时间'] }]"
                  :allowClear="false"
              >
                <a-date-picker
                    v-model:value="form.end"
                    show-time
                    :placeholder="langObj['请选择时间']"
                />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                  name="value"
                  :label="langObj['设备名称']"
                  :rules="[{ required: true }]"
              >
                <!-- <a-input
                    v-model:value="form.machineName"
                    style="width: 210px"
                    readonly
                /> -->
                <span style="color:white">{{getTranslation(form.machineName)}}</span>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                  name="value"
                  :label="langObj['设备区域']"
                  :rules="[{ required: true }]"
              >
                <!-- <a-input
                    v-model:value="form.groupName"
                    style="width: 210px"
                    readonly
                />   -->
                <span style="color:white">{{getTranslation(form.groupName)}}</span>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                  name="maintainPerson"
                  :label="langObj['检修人员']"
                  :rules="[{ required: true }]"
              >
                <a-input
                    v-model:value="form.maintainPerson"
                    style="width: 210px"
                />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item
                  name="condition"
                  :label="langObj['现场设备状态']"
                  :rules="[{ required: true }]"
              >
                <a-select
                    v-model:value="form.condition"
                    style="width: 210px"
                    :placeholder="langObj['请选择现场设备状态']"
                    allowClear
                >
                  <a-select-option
                      v-for="(item, index) in conditionAdd"
                      :key="index"
                      :value="item.value"
                  >
                    {{ langObj[item.label] }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="24">
              <a-form-item
                  name="faultCause"
                  :label="langObj['故障原因']"
                  :rules="[{ required: true }]"
              >
                <a-textarea
                    v-model:value="form.faultCause"
                    :placeholder="langObj['请输入故障原因']"
                    :rows="4"
                />
              </a-form-item>
            </a-col>

            <a-col :span="24">
              <a-form-item
                  name="maintainMessage"
                  :label="langObj['检修内容']"
                  :rules="[{ required: true }]"
              >
                <a-textarea
                    v-model:value="form.maintainMessage"
                    :placeholder="langObj['请输入检修内容']"
                    :rows="4"
                />
              </a-form-item>
            </a-col>

            <a-col :span="24">
              <a-form-item
                  style="margin-left: 10px"
                  name="value"
                  :label="langObj['检修图片']"
              >
                <a-upload
                    v-model:file-list="fileList"
                    list-type="picture-card"
                    @preview="handlePreview"
                    :custom-request="uploadFile"
                    :auto-upload="false"
                    accept="image"
                    :max-count="9"
                >
                  <div v-if="!fileList || fileList.length < 9">
                    <plus-outlined class="opt6" style="color: #fff"/>
                    <div class="opt6" style="margin-top: 8px; color: #fff">
                      {{ langObj['上传'] }}
                    </div>
                  </div>
                </a-upload>
                <a-modal
                    :visible="previewVisible"
                    :title="previewTitle"
                    :footer="null"
                    @cancel="handleCancel"
                >
                  <img alt="example" style="width: 100%" :src="previewImage"/>
                </a-modal>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <div class="w-full flex justify-center">
          <div
              @click="submitAdd"
              style="
              background-color: #171325ff;
              padding: 5px 10px;
              width: 100px;
              font-size: 20px;
              text-align: center;
              cursor: pointer;
            "
          >
            {{ langObj['提交'] }}
          </div>
        </div>
      </div>
    </a-modal>

    <!-- Batch close alarms -->
    <a-modal
        v-model:visible="visibledel"
        :closable="false"
        :footer="null"
        :bodyStyle="{ background: '#080718ff' }"
        style="top: 30%"
        width="1200px"
        :maskClosable="false"
    >
      <div style="color: #fff">
        <div class="w-full flex">
          <div class="flex-1"></div>
          <div class="cursor-pointer" @click="visibledel = false">
            <close-outlined style="font-size: 20px"/>
          </div>
        </div>
        <div class="text-center w-full" style="font-size: 24px">{{ langObj['关闭报警'] }}</div>

        <div class="w-full flex items-center">
          <span style="font-size: 20px"
          >{{ langObj['故障信息（请勾选此次关闭的故障项）'] }}</span
          >
        </div>

        <a-table
            :row-selection="{
            selectedRowKeys: selectedRowKeysDel,
            onChange: onSelectChangeDel,
          }"
            :columns="columns"
            :data-source="nohandleList"
            :pagination="false"
            rowKey="_id"
            style="background-color: #080718ff"
        >
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'condition'">
              <div class="flex items-center">
                <div
                    style="width: 12px; height: 12px; border-radius: 50%"
                    :style="{
                    background: conditionList.find((p) => p.value === text)
                      ?.color,
                  }"
                ></div>
                <div class="ml-2">
                  {{ langObj[conditionList.find((p) => p.value === text)?.label || ""] }}
                </div>
              </div>
            </template>

            <template v-if="column.dataIndex === 'date'">
              {{ transformBeiJingDate(text) }}
            </template>

            <template v-if="column.dataIndex === 'diagnosticNotes'">
              {{getDiagLang(record)}}
            </template>
          </template>
        </a-table>

        <a-form
            ref="formRef"
            name="advanced_search"
            class="ant-advanced-search-form"
            style="margin-top: 20px"
            :model="formClose"
        >
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item name="closeCause" :label="langObj['关闭原因']" required>
                <a-textarea
                    v-model:value="formClose.closeCause"
                    :placeholder="langObj['请输入关闭原因']"
                    :rows="4"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <div class="w-full flex justify-center">
          <div
              @click="submitClose"
              style="
              background-color: #171325ff;
              padding: 5px 10px;
              width: 100px;
              font-size: 20px;
              text-align: center;
              cursor: pointer;
            "
          >
            {{ langObj['提交'] }}
          </div>
        </div>
      </div>
    </a-modal>

  </a-config-provider>
</template>

<script lang="ts" setup>
import { defineProps, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import MaintenanceReportDetailComponent from "../report4/common/maintenanceReportDetails.vue";
import DiagnosticReportDetails2Component from "../report4/common/DiagnosticReportDetails2.vue";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons-vue";
import { langList } from "@/common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getGroupName, transformDate, transformLocalDate, transformBeiJingDate } from "@/common/tools";
import { message } from "ant-design-vue";
import { getLanguage,getTranslation } from "@/common/translate";

const router = useRouter();

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
  langObj.value = langList[language.value]
}
getLang()

const props: any = defineProps({
  machineInfo: null,
});
let machineInfo: any = ref({});

let machine_id = ref();
watch(
    () => props.machineInfo,
    (newValue, oldValue) => {
      machine_id.value = props.machineInfo.id;
      machineInfo.value = props.machineInfo;
      init();
    }
);

onMounted(() => {
  machine_id.value = props.machineInfo?.id;
  machineInfo.value = props.machineInfo;
  init();
});

let conditionList = [
  { label: "健康", value: [0], color: "#61c08f", color2: "#3a3a3aff" },
  { label: "可用", value: [1, 2], color: "#706a00ff", color2: "#706a00ff" },
  { label: "警戒", value: [3, 4, 5], color: "#cd5f3b", color2: "#cd5f3b" },
  { label: "故障", value: [6, 7], color: "#921e37", color2: "#921e37" },
];

const init = () => {
  if (!machine_id.value) return;
  getMachineWarning();
};

// Get device events
let warningType = ref(1);
let warningTotal = ref(0);
let machineWarningData: any = ref([]);
const getMachineWarning = async () => {
  let config: any = {
    params: {
      skip: 1,
      take: 3,
      machineId: machine_id.value,
      typeList: warningType.value === 1 ? [1, 4] : [2],
    },

    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/workflows", config);
  if (result && result.data) {
    machineWarningData.value = result.data.list;
    warningTotal.value = result.data.total;
  }
};

// View more
const viewMore = () => {
  router.push("/warning-manage/warning-list");
};

// View report
let orderId = ref();
let reportId = ref();
let reportType = ref();
let maint = ref();
let Diagn = ref();
const viewReport = (workflow: any) => {
  orderId.value = workflow.id;
  reportType.value = workflow.type;
  if (workflow.reportIds.length) {
    reportId.value = workflow.reportIds[0];
  } else {
    reportId.value = null;
  }

  setTimeout(() => {
    if ((workflow.type === 2 || workflow.type === 3) && reportId.value) {
      maint.value.show(reportId.value);
    }
  }, 500);

  setTimeout(() => {
    if (workflow.type === 1 && reportId.value) {
      Diagn.value.show(reportId.value);
    }
  }, 500);
};
const cancelReport = () => {
  reportId.value = null;
  reportType.value = null;
};

let form: any = ref({
  value: "",
  begin: null,
  end: null,
  type: 2,
  machineName: "",
  machineId: "",
  groupId: "",
  groupName: "",
  factoryId: "",
  condition: null,
  faultCause: "",
});
let nohandleList: any = ref([]);
let visibleAdd = ref(false);
let conditionAdd = [
  { label: "健康", value: 0 },
  { label: "可用", value: 1 },
  { label: "警戒", value: 3 },
  { label: "故障", value: 6 },
];
let columns = [
  {
    title: langObj.value["报警时间"],
    dataIndex: "date",
  },
  {
    title: langObj.value["严重程度"],
    dataIndex: "condition",
  },
  {
    title: langObj.value["故障描述"],
    dataIndex: "diagnosticNotes",
  },
];
const addRepair = () => {
  machineInfo.value.groupName = getGroupName(machineInfo.value.groupId);
  form.value.groupName = machineInfo.value.groupName;
  form.value.machineName = machineInfo.value.machineName;
  form.value.machineId = machineInfo.value.machineId;
  form.value.groupId = machineInfo.value.groupId;
  form.value.factoryId = machineInfo.value.factoryId;
  form.value.maintainPerson = JSON.parse(
      localStorage.getItem("memberInfo") || ""
  )?.nickName;
  nohandleList.value = [];
  visibleAdd.value = true;
  getNotHandleOrder();
};

// Get unresolved diagnosis work orders
const getNotHandleOrder = async () => {
  let config: any = {
    params: {
      machineId: machine_id.value,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/workflows/nohandle", config);
  if (result && result.data) {
    nohandleList.value = result.data;
  }
};

let selectedRowKeys = ref<any[]>([]);
const onSelectChange = (ev: any) => {
  selectedRowKeys.value = ev;
};

const submitAdd = async () => {
  let submit = JSON.parse(JSON.stringify(form.value));
  if (!submit.begin) {
    message.warning(langObj.value["请选择开始时间"]);
    return;
  } else {
    submit.begin = transformDate(submit.begin);
  }

  if (!submit.end) {
    message.warning(langObj.value["请选择结束时间"]);
    return;
  } else {
    submit.end = transformDate(submit.end);
  }

  if (!submit.maintainPerson) {
    message.warning(langObj.value["请填写检修人员"]);
    return;
  }

  if (!submit.condition && submit.condition !== 0) {
    message.warning(langObj.value["请选择现场设备状态"]);
    return;
  }

  if (!submit.faultCause) {
    message.warning(langObj.value["请填写故障原因"]);
    return;
  }

  if (!submit.maintainMessage) {
    message.warning(langObj.value["请填写检修内容"]);
    return;
  }

  let list = nohandleList.value.filter((p: any) =>
      selectedRowKeys.value.includes(p._id)
  );

  submit.list = list.map((d: any) => ({
    date: d.date,
    condition: d.condition,
    diagnosticNotes: d.diagnosticNotes,
    id: d._id,
  }));

  if (fileList.value && fileList.value.length) {
    submit.pictures = fileList.value.map((p: any) => ({
      url: p.url,
    }));
  } else {
    submit.pictures = [];
  }

  submit.begin = transformBeiJingDate(submit.begin)
  submit.end = transformBeiJingDate(submit.end)

  let data: any = {
    repairReport: submit,
    date: submit.end,
    machineIds: [machine_id.value],
    factoryId: submit.factoryId,
    pictures: submit.pictures,
    type: 2,
    workflow: true,
  };

  let result = await request.post("/api/reports", data);

  if (result && result.status) {
    message.success(langObj.value["新增成功"]);
    visibleAdd.value = false;
    await getMachineWarning();
  } else {
    message.warning(langObj.value["操作失败"] + "!");
  }
};

// Batch close alarms
let formClose = ref({
  closeCause: "",
});

let visibledel = ref(false);
const deleteWaring = () => {
  formClose.value.closeCause = "";
  nohandleList.value = [];
  visibledel.value = true;
  getNotHandleOrder();
};

// Close alarm
let selectedRowKeysDel: any = ref([]);

const onSelectChangeDel = (ev: any) => {
  selectedRowKeysDel.value = ev;
};

const submitClose = async () => {
  if (!formClose.value.closeCause) {
    message.warning(langObj.value["请填写关闭原因"]);
    return;
  }
  if (!selectedRowKeysDel.value || !selectedRowKeysDel.value.length) {
    message.warning(langObj.value["请选择关闭的故障项"]);
    return;
  }

  let form = {
    closeCause: formClose.value.closeCause,
    list: [],
  };

  let list = nohandleList.value.filter((p: any) =>
      selectedRowKeysDel.value.includes(p._id)
  );
  if (list && list.length) {
    form.list = list.map((d: any) => ({
      date: d.date,
      condition: d.condition,
      diagnosticNotes: d.diagnosticNotes,
      id: d._id,
    }));
  }
  let result = await request.post("/api/workflows/close", form);
  if (result && result.status == 200) {
    message.success(langObj.value["关闭成功"] + "!");
    visibledel.value = false;
  } else {
    message.warning(langObj.value["操作失败"]);
  }
};

// **Image upload**
let fileList = ref<any>([]);
const previewVisible = ref(false);
const previewImage = ref("");
const previewTitle = ref("");
const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = "";
};

const handlePreview = async (file: any) => {
  previewImage.value = file.url;
  previewVisible.value = true;
  previewTitle.value = file.url;
};

let uploadFile = async (options: any) => {
  const { onSuccess, onError, file } = options;
  let formData = new FormData();
  formData.append("file", file); // file is the file to upload
  const config = {
    headers: {
      requestId: uuidv4(),
      "Content-Type": "multipart/form-data",
    },
  };
  let res = await request.post("/api/upload", formData, config);
  if (res) {
    file.url = res.data;
    onSuccess({ url: file.url, status: "done" });
  }
};

let getDiagLang = (record) => {
  try {
    if (record.diagnosticNotes.includes('测点：')) {
      let arr = record.diagnosticNotes.split("；");
      if (arr.length > 1) {
        let s1 = arr[0].split("：");
        let s1_1 = getLanguage(s1[0]);
        let s1_2 = getTranslation(s1[1]);

        let s2 = arr[1].split("：");
        
        let s2str = getLanguage(s2[0])+'：'+s2[1].replace('超过1级阈值',getLanguage('超过1级阈值')).replace('超过2级阈值',getLanguage('超过2级阈值')).replace('超过3级阈值',getLanguage('超过3级阈值'))

        return s1_1 + "：" + s1_2 + "；"+s2str;
      } else {
        return record.diagnosticNotes
      }
    } else {
      let arr = record.diagnosticNotes.split("；").filter((p:any) => p)
      let strArr:any = []
      arr.map((d:any) => {
        let s1 = getTranslation(d.split("：")[0]);
        let s2 = d.split("：")[1]
        let s2L = s2.split("，").filter((p:any) => p)
        let s3L:any = []
        s2L.map((d:any) => {
          s3L.push(getLanguage(d)) 
        })
        let s3 = s3L.join("，")
        let s4 = s1 + "：" + s3;
        strArr.push(s4)
      })
      return strArr.join("；")
    }
  } catch (error) {
    console.log('error', error)
    return record.diagnosticNotes
  }
};
</script>


<style scoped lang="less">
.size18 {
  font-size: 18px;
}

.box5 {
  width: 100%;
  border-radius: 2px;
  border: 1px solid #171325ff;
  padding: 10px;
}

.opt6 {
  opacity: 0.6;
}

.opt8 {
  opacity: 0.8;
}

.btn1 {
  width: 80px;
  border-radius: 2px;
  opacity: 1;
  border: 1px solid #3a3a3aff;
  text-align: center;
  padding: 5px 5px;
}

.btn2-o {
  border-radius: 2px;
  border: 1px solid #171325ff;
  background: #ffc000;
  color: #000000ff;
}

</style>
